import PropTypes from "prop-types";
import { defaultLocale, CHINESE_CODE, CHINESE_CODE_FULL } from "./i18nUtil";
import { translateText } from "./translateUtils";
export function translate(text, target, callback) {
  // need to check for chinese, and add the -TW back in for google to translate correctly.
  const locale = target === CHINESE_CODE ? CHINESE_CODE_FULL : target;
  if (locale === defaultLocale) {
    callback(text);
  } else if (typeof text === "string" || Array.isArray(text)) {
    translateText(text, callback, locale);
  } else if (typeof text === "object") {
    console.warn("Invalid translation data type.  Only Strings and Arrays are allowed");
    callback(text);
  }
}

translate.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  target: PropTypes.string,
  callback: PropTypes.func,
};
